import { useState, type FormEvent } from 'react';
import { api, type Nutzer } from '../api/client';
import { Feld, Meldung, fehlerText } from '../components/ui';

export function Anmeldung({ onAngemeldet }: { onAngemeldet: (n: Nutzer) => void }) {
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function senden(e: FormEvent) {
    e.preventDefault();
    setLaeuft(true);
    setFehler(null);
    try {
      onAngemeldet((await api.anmelden(email, passwort)).nutzer);
    } catch (err) {
      setFehler(fehlerText(err));
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="anmeldung">
      <form className="kasten anmeldung__form" onSubmit={(e) => void senden(e)}>
        <h1>Anmelden</h1>
        <p className="gedaempft">Einsatzplanung für Umzüge im öffentlichen Raum.</p>
        <Feld label="E-Mail">
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Feld>
        <Feld label="Passwort">
          <input
            type="password"
            autoComplete="current-password"
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
            required
          />
        </Feld>
        {fehler && <Meldung art="fehler">{fehler}</Meldung>}
        <button type="submit" className="knopf knopf--primaer" disabled={laeuft}>
          {laeuft ? 'Meldet an …' : 'Anmelden'}
        </button>
      </form>
    </div>
  );
}
